import { client } from './client';

export default client;
